export default "__VITE_ASSET__dbc5eec4__"